import styled from 'styled-components';

const PageScrollVisibleWrapper = styled.div`
  width: 100%;
  margin-top: 0;
  overflow-y: scroll;
`;

export default PageScrollVisibleWrapper;
